export default "__VITE_ASSET__D3R5O_ec__"